import Icon from './Icon';
import { testimonials } from '../constants/content';

export default function Testimonials() {
  return (
    <section className="section" id="reviews">
      <div className="container">
        <div className="sec-head sec-head--center">
          <p className="kicker">Customer Stories</p>
          <h2 className="sec-title">Rated 4.8 out of 5 by our customers</h2>
          <p className="sec-lead">
            Real feedback from people who called us with a problem and hung up with working
            protection.
          </p>
        </div>

        <div className="testi-grid">
          {testimonials.map((item) => (
            <article key={item.name} className="testi">
              <div className="testi__stars" aria-label={`${item.rating} out of 5 stars`}>
                {Array.from({ length: item.rating }).map((_, i) => (
                  <Icon key={i} name="star" size={16} fill />
                ))}
              </div>
              <p className="testi__quote">&ldquo;{item.quote}&rdquo;</p>
              <div className="testi__who">
                <span className="testi__avatar" aria-hidden="true">
                  {item.name.charAt(0)}
                </span>
                <div>
                  <p className="testi__name">{item.name}</p>
                  <p className="testi__role">{item.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
